import { render, staticRenderFns } from "./form-accordion.vue?vue&type=template&id=4bf766f3"
import script from "./form-accordion.vue?vue&type=script&lang=js"
export * from "./form-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports